import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import type { BulkAdPropertyUpdate } from "../../../zodios/apiDefinitions/api/ads";
import { errorToast, successToast } from "../../../utils/toasts";
import { invalidateAdQueries } from "../../perf_reports/api/ads/invalidateAdQueries";

export function useBulkUpdateAdPropertiesV2() {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["advertising"]);
  return useMutation({
    mutationFn: async (vars: BulkAdPropertyUpdate) => await apiClient.updateAdPropertiesV2(vars),
    onSuccess: (_data, vars) => {
      successToast({
        message: t(($) => $.advertising["Media Plans Updated"], { count: vars.advertisements.length }),
      });
      invalidateAdQueries(queryClient);
    },
    onError: (error, vars) => {
      errorToast({
        message: t(($) => $.advertising["Failed to update Media Plans"], { count: vars.advertisements.length }),
        error,
      });
    },
  });
}
